<template>
	<AuthShell>
		<v-container class="main-container" fluid>
			<v-card class="login-card">
				<v-card-title class="modal-header login-title">{{ $t('forgot_password_title') }}</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="login-body">
					<form class="modal-body login-form" @submit.prevent="submit">
						<p class="hint">{{ $t('forgot_password_hint') }}</p>

						<template v-if="!sent">
							<div class="field-block">
								<v-text-field
									ref="emailField"
									class="input"
									:placeholder="$t('email')"
									v-model="email"
									type="email"
									autocomplete="email"
									outlined
									hide-details="auto"
									:error="!!emailError"
									:error-messages="emailError"
									:disabled="isLoading"
									@input="clearError"
								></v-text-field>
							</div>
							<p v-if="systemError" class="system-error" role="alert">{{ systemError }}</p>
						</template>

						<p v-else class="success-banner" role="status">{{ $t('forgot_password_sent') }}</p>
					</form>
				</v-card-text>
				<v-card-actions class="buttons-container buttons-container--split">
					<Button v-if="!sent" skin="primary" :disabled="isLoading" @click="submit">
						{{ isLoading ? $t('loading') : $t('send_reset_link') }}
					</Button>
					<router-link class="back-link" to="/login">{{ $t('back_to_login') }}</router-link>
				</v-card-actions>
			</v-card>
		</v-container>
	</AuthShell>
</template>

<script>
import Button from '@/modules/common/components/Button'
import AuthShell from '@/modules/auth/components/AuthShell'
import authService from '@/modules/auth/services/authService'
import { isValidEmail, focusField } from '@/modules/auth/passwordRules'

export default {
	name: 'ForgotPassword',
	components: { Button, AuthShell },
	data() {
		return {
			email: '',
			isLoading: false,
			sent: false,
			emailError: '',
			systemError: ''
		}
	},
	mounted() {
		this.$nextTick(() => focusField(this.$refs.emailField))
	},
	methods: {
		clearError() {
			this.emailError = ''
			this.systemError = ''
		},
		async submit() {
			if (this.isLoading || this.sent) return
			this.clearError()

			const trimmed = (this.email || '').trim()
			if (!isValidEmail(trimmed)) {
				this.emailError = this.$t('forgot_password_invalid_email')
				this.$nextTick(() => focusField(this.$refs.emailField))
				return
			}

			this.isLoading = true
			try {
				await authService.forgotPassword(trimmed)
				this.sent = true
			} catch (err) {
				this.systemError = err && err.validationCode === 'TOO_MANY_RESET_REQUESTS'
					? this.$t('forgot_password_too_many')
					: this.$t('forgot_password_failed')
			} finally {
				this.isLoading = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@use '../styles/authCard';
</style>
